import {
  FaHome,
  FaUser,
  FaBriefcase,
  FaGraduationCap,
  FaTools,
  FaLaptopCode,
  FaFileAlt,
  FaAddressCard,
} from 'react-icons/fa';
import { MotionConfig } from 'motion/react';
import Footer from  './components/Footer';
import Router from './components/Router';
import './App.css';

const menuList = [
  { label: 'Home', type: 'scroll', icon: FaHome },
  { label: 'About', type: 'scroll', icon: FaUser },
  { label: 'Experience', type: 'scroll', icon: FaBriefcase },
  { label: 'Education', type: 'scroll', icon: FaGraduationCap },
  { label: 'Skills', type: 'scroll', icon: FaTools },
  { label: 'Projects', type: 'scroll', icon: FaLaptopCode },
  { label: 'Contact', type: 'scroll', icon: FaAddressCard },
  {
    label: 'Resume',
    type: 'external',
    href: 'https://drive.google.com/file/d/1CC1bXZJqWtsIQV3YkMPi9EHvcbahP6iO/view?usp=sharing',
    newTab: true,
    icon: FaFileAlt,
  },
];

const App = () => {
  return (
    <MotionConfig reducedMotion="user">
      <div className="app">
        <Router menuList={menuList} />
        <Footer />
      </div>
    </MotionConfig>
  );
}

export default App;
